import {Directive, ElementRef, EventEmitter, Input, Output, Renderer2} from '@angular/core';
import {checkForPermission} from './check-permission';


@Directive({selector: '[tableRowPermission]'})
export class ClickPermissionDirective {
  permission: boolean;
  @Output() permissionClick: EventEmitter<any> = new EventEmitter();

  constructor(public elementRef: ElementRef, private renderer: Renderer2) {
    this.listenRenderer();
  }

  @Input() set tableRowPermission(p: string) {
    const permissionCheck = checkForPermission(p);
    if (permissionCheck) {
      this.permission = true;
      this.renderer.addClass(this.elementRef.nativeElement, 'pointer');
      return;
    }
    this.permission = false;
  }

  listenRenderer() {
    this.renderer.listen(this.elementRef.nativeElement, 'click', event => {
      if (!this.permission) {
        return;
      }
      this.permissionClick.emit(event);
    });
  }

}
